export const actionTypes = {
	SetWidgetExpanded: 'SetWidgetExpanded',
	ResetDashboard: 'ResetDashboard',
};

const initialState = {
	expandedWidget: null, // null quando nenhum widget está expandido, ou o nome do widget expandido
	onBackClick: null, // função de callback para voltar
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SetWidgetExpanded: {
			return {
				...state,
				expandedWidget: action.payload.widgetName,
				onBackClick: action.payload.onBackClick,
			};
		}

		case actionTypes.ResetDashboard: {
			return {
				...state,
				expandedWidget: null,
				onBackClick: null,
			};
		}

		default:
			return state;
	}
};

export const actions = {
	setWidgetExpanded: (widgetName, onBackClick) => ({
		type: actionTypes.SetWidgetExpanded,
		payload: { widgetName, onBackClick },
	}),
	resetDashboard: () => ({ type: actionTypes.ResetDashboard }),
};

export function* saga() {}
